function makeRuleNo(value) {
    return value;
}
export class IndexedRules {
    constructor(table) {
        this.table = table;
        this.optionHashCache = new Map();
        this.currentRules = new Set();
        this.appliedFilters = new Map();
        this.involvedOptionPaths = [];
        this.ruleSelectors = new Map();
        this.optionSelectors = new Map();
        this.indexes = new Map();
        this.rulesLinks = [];
        this.appliedHashes = new Map();
        this.init();
    }
    init() {
        this.allRulesSet = new Set();
        for (let i = 0; i < this.table.rules.length; i++) {
            this.allRulesSet.add(makeRuleNo(i));
        }
        this.currentRules = this.allRulesSet;
        const optionPaths = Array.from(this.table.getCompatibilityInvolvedOptionPaths());
        this.involvedOptionPaths = optionPaths;
        for (const optionPath of optionPaths) {
            const { optionHashSelector, ruleHashSelector } = this.table.createOptionPropertiesSelector(optionPath);
            this.ruleSelectors.set(optionPath, ruleHashSelector);
            this.optionSelectors.set(optionPath, (option) => {
                let map = this.optionHashCache.get(option);
                if (!map) {
                    map = new Map();
                    this.optionHashCache.set(option, map);
                }
                let optionHash = map.get(optionPath);
                if (!optionHash) {
                    optionHash = optionHashSelector(option);
                    map.set(optionHash, optionHash);
                }
                return optionHash;
            });
        }
        this.hashRules(this.table.rules);
    }
    hashRules(rules) {
        for (const optionPath of this.involvedOptionPaths) {
            this.indexes.set(optionPath, new Map());
        }
        for (let i = 0; i < rules.length; i++) {
            let rule = rules[i];
            this.rulesLinks[i] = new Map();
            for (const optionPath of this.involvedOptionPaths) {
                const ruleHashForOption = this.ruleSelectors.get(optionPath)(rule);
                const indexHash = this.indexes.get(optionPath);
                let indexHashRules = indexHash.get(ruleHashForOption);
                if (!indexHashRules) {
                    indexHashRules = new Set();
                    indexHash.set(ruleHashForOption, indexHashRules);
                }
                indexHashRules.add(makeRuleNo(i));
                this.rulesLinks[i].set(optionPath, ruleHashForOption);
            }
        }
    }
    matchOne(optionPath, optionHash) {
        const optionRules = this.indexes.get(optionPath).get(optionHash);
        if (!optionRules) {
            return false;
        }
        for (let rule of optionRules) {
            if (this.currentRules.has(rule)) {
                return true;
            }
        }
        return false;
    }
    applyFilter(optionPath, optionHash) {
        var _a;
        this.appliedFilters.set(optionPath, optionHash);
        const newCurrentRules = new Set();
        const optionRules = (_a = this.indexes.get(optionPath).get(optionHash)) !== null && _a !== void 0 ? _a : new Set();
        if (optionRules.size < this.currentRules.size) {
            for (let rule of optionRules) {
                if (this.currentRules.has(rule)) {
                    newCurrentRules.add(rule);
                }
            }
        }
        else {
            for (let rule of this.currentRules) {
                if (optionRules.has(rule)) {
                    newCurrentRules.add(rule);
                }
            }
        }
        this.currentRules = newCurrentRules;
    }
    resetFilter(optionPath) {
        if (!this.appliedFilters.has(optionPath)) {
            return;
        }
        this.appliedFilters.delete(optionPath);
        if (this.appliedFilters.size == 0) {
            this.currentRules = this.allRulesSet;
            return true;
        }
        const newCurrentRules = new Set();
        for (let [path, optionHash] of this.appliedFilters) {
            const rules = this.indexes.get(path).get(optionHash);
            for (let rule of rules) {
                newCurrentRules.add(rule);
            }
        }
        this.currentRules = newCurrentRules;
    }
    anyMatch() {
        return this.currentRules.size > 0;
    }
    resetAll() {
        this.appliedFilters = new Map();
        this.currentRules = this.allRulesSet;
    }
}
//# sourceMappingURL=IndexedRules.js.map